import React, { useImperativeHandle } from 'react'
import { Snackbar, Slide } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import { useDispatch } from 'react-redux'
import { setIsStored } from '../../redux/slices/Alerts'
import { useNavigate } from 'react-router-dom'

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const Alerts = React.forwardRef(
  ({ severity = 'success', stateInitial, children }, ref) => {
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const [open, setOpen] = React.useState(stateInitial ?? false)
    const [goRute, setGoRute] = React.useState(null)
    const [message, setMessage] = React.useState(null)
    const [isSeverity, setSeverity] = React.useState(null)

    useImperativeHandle(ref, () => ({
      openAlert: value => setOpen(value),
      goRute: value => setGoRute(value),
      message: value => setMessage(value),
      isSeverity: value => setSeverity(value),
    }))

    const handleClose = (event, reason) => {
      if (reason === 'clickaway') return
      setOpen(false)
      if (goRute) navigate(goRute)
    }

    React.useEffect(() => {
      if (open) return
      dispatch(setIsStored(null))
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    if (!open) return null

    return (
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={7000}
        key="AlertTransitionLeft"
        TransitionComponent={TransitionLeft}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ zIndex: 9999 }}>
        <Alert
          severity={isSeverity ?? severity}
          onClose={handleClose}
          sx={{ width: '100%' }}>
          {message ?? children}
        </Alert>
      </Snackbar>
    )
  }
)

export default Alerts
